<script>
import WireTransferCardContent from './comp_WireTransferCardContent.vue'
export default {
	props: ['order', 'checkout'],
	extends: WireTransferCardContent,
}
</script>
